import 'normalize.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { QueryCache, ReactQueryCacheProvider } from 'react-query';
import Routes from './routes';
import storeConfig, { history } from './store';

const queryCache = new QueryCache({
  defaultConfig: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const store = storeConfig();
export default store;

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ReactQueryCacheProvider queryCache={queryCache}>
        <Routes />
      </ReactQueryCacheProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
